// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3j1WC","colCheckbox":"styles_colCheckbox__4O8v3"};